function addCareRecipient () {
  let url = window.location.origin
  window.open(url + `/care_recipients/new`, '_blank');
  return true;
}
export default addCareRecipient;
